<template>
  <!-- <div class="chat-container">
    <div class="message-container" ref="messageContainer">
      <div 
        v-for="(message, index) in messages" 
        :key="index"
        :class="['message', message.type + '-message']"
      >
        <div v-if="message.type === 'bot'" v-html="renderMarkdown(message.content)"></div>
        <div v-else>{{ message.content }}</div>
      </div>
    </div>
    <div class="input-container">
      <input 
        v-model="inputMessage" 
        @keyup.enter="sendMessage"
        placeholder="输入您的问题..."
        class="message-input"
        :disabled="!isConnected"
      >
      <button 
        @click="sendMessage" 
        class="send-button"
        :disabled="!isConnected"
      >
        发�?
      </button>
    </div>
    <div v-if="!isConnected" class="connection-status">
      连接已断开，正在重新连�?...
    </div>
  </div> -->

  <div class="flex h-screen">
    <Left ref="leftComponent" />
    <Chat ref="chatComponent" @favorite-count-changed="onFavoriteCountChanged" @conversation-saved="onConversationSaved" />
    <Right @question-clicked="onQuestionClicked" @export-chat-history="onExportChatHistory" @share-chat="onShareChat" />
  </div>

</template>

<script>
// 移除不需要的WebSocket相关import
// import SockJS from 'sockjs-client';
// import { marked } from 'marked';
// import DOMPurify from 'dompurify';

import Left from './Left.vue'
import Chat from './Chat.vue'
import Right from './Right.vue'

// 移除marked配置，由Chat.vue组件处理
// marked.setOptions({
//   gfm: true,
//   breaks: true,
//   highlight: function (code, lang) {
//     return code;
//   }
// });

export default {
  name: 'ChatWindow',
  components: {
    Left, Chat, Right
  },
  data() {
    return {
      // 移除WebSocket相关数据，由Chat.vue组件处理
      // ws: null,
      // messages: [],
      // inputMessage: '',
      // isConnected: false,
      // reconnectAttempts: 0,
      // maxReconnectAttempts: 5,
      // currentResponse: ''
      tokenValidationTimer: null,
      tokenValidationInterval: 5 * 60 * 1000 // 5分钟检查一次
    }
  },
  mounted() {
    // 检查登录状态
    this.checkAuthStatus();
    // 启动定期检查token有效性
    this.startTokenValidation();
    // 移除WebSocket初始化，由Chat.vue组件处理
    // this.initWebSocket();
  },
  beforeDestroy() {
    // 清除定时器
    this.stopTokenValidation();
    // 移除WebSocket关闭，由Chat.vue组件处理
    // this.closeWebSocket()
  },
  methods: {
    // 对话已保存，刷新历史记录
    onConversationSaved() {
      // 可以在这里添加刷新逻辑，比如通知历史对话页面刷新
      console.log('对话已保存，可以刷新历史记录');
    },
    
    checkAuthStatus() {
      const token = localStorage.getItem('token');
      const sessionId = localStorage.getItem('sessionId');
      const displayName = localStorage.getItem('displayName');
      
      console.log('检查认证状态:');
      console.log('token:', token ? '存在' : '不存在');
      console.log('sessionId:', sessionId ? '存在' : '不存在');
      console.log('displayName:', displayName ? '存在' : '不存在');
      
      if (!token || !sessionId || !displayName) {
        console.log('登录信息缺失，跳转到登录页');
        this.$router.push('/login');
        return;
      }
      
      console.log('用户已登录:', displayName);
    },
    
    // 启动定期token验证
    startTokenValidation() {
      this.tokenValidationTimer = setInterval(() => {
        this.validateToken();
      }, this.tokenValidationInterval);
    },
    
    // 停止token验证
    stopTokenValidation() {
      if (this.tokenValidationTimer) {
        clearInterval(this.tokenValidationTimer);
        this.tokenValidationTimer = null;
      }
    },
    
    // 验证token有效性
    async validateToken() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.handleAuthFailure('Token不存在');
          return;
        }
        
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/auth/validate-token`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          }
        });
        
        const result = await response.json();
        
        if (result.code !== 200 || !result.data.valid) {
          this.handleAuthFailure(result.data.message || 'Token验证失败');
        }
      } catch (error) {
        console.error('Token验证失败:', error);
        this.handleAuthFailure('网络错误，请重新登录');
      }
    },
    
    // 处理认证失败
    handleAuthFailure(message) {
      console.log('认证失败:', message);
      // 清除本地存储
      localStorage.removeItem('token');
      localStorage.removeItem('sessionId');
      localStorage.removeItem('displayName');
      localStorage.removeItem('loginAccount');
      localStorage.removeItem('userId');
      
      // 显示提示信息
      alert(`认证失败：${message}，即将跳转到登录页面`);
      
      // 跳转到登录页面
      this.$router.push('/login');
    },
    
    // 移除WebSocket相关方法，由Chat.vue组件处理
    // initWebSocket() { ... },
    // closeWebSocket() { ... },
    // reconnect() { ... },
    // sendMessage() { ... },
    // renderMarkdown(content) { ... },
    // appendMessage(type, content) { ... },
    
    // 处理收藏数量变化事件
    onFavoriteCountChanged() {
      console.log('收到收藏数量变化事件，通知Left组件更新');
      if (this.$refs.leftComponent) {
        this.$refs.leftComponent.loadFavoriteCount();
      }
    },
    
    // 处理相关问题点击事件
    onQuestionClicked(questionContent) {
      console.log('收到相关问题点击事件:', questionContent);
      if (this.$refs.chatComponent) {
        // 将问题内容传递给Chat组件
        this.$refs.chatComponent.setInputMessage(questionContent);
      }
    },
    
    // 处理导出对话记录事件
    onExportChatHistory() {
      console.log('导出对话记录');
      if (this.$refs.chatComponent) {
        this.$refs.chatComponent.exportChatHistory();
      }
    },
    
    // 处理分享对话事件
    onShareChat() {
      console.log('分享对话');
      if (this.$refs.chatComponent) {
        this.$refs.chatComponent.shareChat();
      }
    }
  }
}
</script>

<style scoped>
/* .chat-container {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
}

.message-container {
  flex: 1;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 20px;
  overflow-y: auto;
  margin-bottom: 20px;
  background: #f9f9f9;
}

.input-container {
  display: flex;
  gap: 10px;
}

.message-input {
  flex: 1;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.message-input:disabled,
.send-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.send-button {
  padding: 0 20px;
  background: #409EFF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
}

.send-button:hover:not(:disabled) {
  background: #66b1ff;
}

.message {
  margin: 10px 0;
  padding: 10px;
  border-radius: 4px;
  max-width: 80%;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.5;
}

.user-message {
  color: #409EFF;
  background: #ecf5ff;
  margin-left: auto;
}

.bot-message {
  color: #67C23A;
  background: #f0f9eb;
  font-size: 14px;
  font-family: "Microsoft YaHei", sans-serif;
}

.bot-message :deep(h1),
.bot-message :deep(h2),
.bot-message :deep(h3),
.bot-message :deep(h4),
.bot-message :deep(h5),
.bot-message :deep(h6) {
  margin: 8px 0;
  font-weight: 600;
}

.bot-message :deep(p) {
  margin: 8px 0;
  line-height: 1.6;
}

.bot-message :deep(code) {
  background-color: #f3f3f3;
  padding: 2px 4px;
  border-radius: 3px;
  font-family: Consolas, Monaco, 'Andale Mono', monospace;
}

.bot-message :deep(pre) {
  background-color: #f6f8fa;
  padding: 16px;
  border-radius: 6px;
  overflow-x: auto;
}

.bot-message :deep(pre code) {
  background-color: transparent;
  padding: 0;
}

.bot-message :deep(ul),
.bot-message :deep(ol) {
  padding-left: 20px;
  margin: 8px 0;
}

.bot-message :deep(blockquote) {
  margin: 8px 0;
  padding-left: 10px;
  border-left: 4px solid #dfe2e5;
  color: #6a737d;
}

.bot-message :deep(table) {
  border-collapse: collapse;
  width: 100%;
  margin: 8px 0;
}

.bot-message :deep(th),
.bot-message :deep(td) {
  border: 1px solid #dfe2e5;
  padding: 6px 13px;
}

.bot-message :deep(th) {
  background-color: #f6f8fa;
}

.bot-message :deep(a) {
  color: #0366d6;
  text-decoration: none;
}

.bot-message :deep(a:hover) {
  text-decoration: underline;
}

.bot-message :deep(img) {
  max-width: 100%;
  height: auto;
}

.connection-status {
  text-align: center;
  color: #E6A23C;
  padding: 10px;
  background: #fdf6ec;
  border-radius: 4px;
  margin-top: 10px;
}

.error-message {
  color: #F56C6C;
  background: #fef0f0;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
} */
</style> 